<template>
<div>
    <h2 class="text-center">
        {{ title }}
    </h2>
    <table
        v-if="is_print_for_customer"
        class="table-border mx-auto"
    >
        <thead>
            <tr>
                <th>STT</th>
                <th>PHÂN LOẠI</th>
                <th>PHÒNG</th>
                <th>TIỀN CHƯA THU</th>
                <th>GHI CHÚ</th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="(item, index) in items_filter"
                :key="item.payment_id"
            >
                <template  v-if="index !== items_filter.length - 1">
                    <td>{{ index + 1  }}</td>
                    <td>{{ item.type  }}</td>
                    <td>{{ item.object  }}</td>
                    <td>{{ item.end_balance | formatCurrency }}</td>
                    <td>{{ item.note }}</td>
                </template>
                <template v-else>
                    <td></td>
                    <td style="font-weight: bold;">{{ item.type  }}</td>
                    <td>{{ item.object  }}</td>
                    <td style="font-weight: bold;">{{ item.end_balance | formatCurrency }}</td>
                    <td>{{ item.note }}</td>
                </template>
            </tr>
        </tbody>
    </table>
    <table
        v-else
        class="table-border mx-auto"
    >
        <thead>
            <tr>
                <th>PHÂN LOẠI</th>
                <th>TÀI KHOẢN</th>
                <th>ĐỐI TƯỢNG</th>
                <th>SỐ DƯ ĐẦU KỲ</th>
                <th>PHÁT SINH TĂNG</th>
                <th>PHÁT SINH GIẢM</th>
                <th>SỐ DƯ CUỐI KỲ</th>
            </tr>
        </thead>
        <tbody>
            <tr
                v-for="(item, index) in items_filter"
                :key="item.payment_id"
            >
                <td>{{ item.type  }}</td>
                <td>{{ item.account  }}</td>
                <td>{{ item.object  }}</td>
                <td>{{ item.opening_balance | formatCurrency }}</td>
                <td>{{ item.increase | formatCurrency }}</td>
                <td>{{ item.decrease | formatCurrency }}</td>
                <td>{{ item.end_balance | formatCurrency }}</td>
            </tr>
        </tbody>
    </table>
    <div style="break-after: page"></div>
</div>
</template>

<script>
import moment from 'moment';
import { translateBuildingName, formatTimeServer } from 'Helpers';
export default {
    name: "print-bang-tong-hop-cong-no",
    props: {
        items: Array,
        chosen_building: String,
        is_print_all: Boolean,
        is_print_for_customer: Boolean,
        is_print_prior_months_debt: Boolean,
        summary_row: Object,
        chosen_month: String,
    },
    data(){
        return {}
    },
    computed: {
        items_filter() {
            let show_items;
            if (this.is_print_prior_months_debt) {
                // Phòng có nợ chuyển từ các tháng trước (opening_balance > 0) và tới giờ vẫn còn nợ (end_balance > 0)
                show_items = this.items.filter((item) => item.opening_balance > 0 && item.end_balance > 0);
            } else if (this.is_print_all) {
                show_items = this.items;
            } else {
                show_items = this.items.filter((item) => item.end_balance > 0);
            }

            const sum_debt_row = {
                type: "Tổng cộng",
                object: '',
                end_balance: show_items.reduce((acc, cur) => acc + cur.end_balance, 0),
                note: '',
            }

            return !this.is_print_for_customer ? [this.summary_row, ...show_items] : [...show_items, sum_debt_row];
        },
        title(){
            const building_name = translateBuildingName(this.chosen_building);
            let reportSubtitle;
            if (this.is_print_prior_months_debt) {
                reportSubtitle = `Danh sách nợ tiền phòng các tháng trước - tính đến ${moment().format("HH:mm DD/MM/YYYY")}`;
            } else if (this.is_print_for_customer) {
                reportSubtitle = "Danh sách nợ tiền phòng tháng " + formatTimeServer(this.chosen_month, "MM/YYYY");
            } else if (this.is_print_all) {
                reportSubtitle = "Bảng tổng hợp công nợ đầy đủ tháng " + formatTimeServer(this.chosen_month, "MM/YYYY");
            } else {
                reportSubtitle = "Bảng tổng hợp công nợ rút gọn tháng " + formatTimeServer(this.chosen_month, "MM/YYYY");
            }
            const title = building_name ? `${reportSubtitle} tòa nhà ${building_name}` : reportSubtitle;
            return title.toUpperCase();
        }
    }
};
</script>

<style>
</style>